//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'
const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')

import wcs from '@/scripts/libs/wcs'
import { DELIVERY_DETAILS_VIEW, PAYMENT_DETAILS_VIEW } from '@/scripts/constants/pages'

const { viewTaskName } = wcs.getStoreConfig()

export default {
  name: 'rb-header-eyemed-bar',
  computed: {
    ...mapGettersPdp(['isEyeMedApplied']),
    isEyeMedEnabledInThisPage() {
      return (
        wcs.isInCart() ||
        viewTaskName === DELIVERY_DETAILS_VIEW ||
        viewTaskName === PAYMENT_DETAILS_VIEW
      )
    },
  },
  watch: {
    isEyeMedApplied() {
      this.fixActionsContainer()
    },
  },
  mounted() {
    if (this.isEyeMedApplied) {
      this.fixActionsContainer()
    }
  },
  methods: {
    fixActionsContainer() {
      const headerActionsContainer = document.getElementsByClassName(
        'rb-header__actions-container'
      )[0]
      if (headerActionsContainer) {
        headerActionsContainer.classList.add('rb-eyemed-applied')
      }
    },
  },
}
